import React, { Component } from 'react';
import './styles.css';

class Privacy extends Component {
	render() {
		return (
			<div className="privacy">
				<h2>Informativa di TIM sul trattamento dei dati personali </h2>
				<p>
					Nel rispetto della normativa sulla protezione dei dati personali, TIM
					La informa che i Suoi dati personali da Lei forniti sul form presente
					su questo sito saranno trattati da TIM stessa e da suoi partner
					commerciali (nominati Responsabili del trattamento), al solo fine di
					poterla contattare, come da sua richiesta, tramite telefono con
					operatore per fornirle assistenza, informazioni e/o per proporLe
					offerte relative a prodotti e/o servizi TIM, nonché per le connesse
					attività. Inoltre, i Suoi dati potranno essere trattati per adempiere
					agli obblighi previsti da leggi, regolamenti o normative comunitarie,
					nonché da disposizioni delle Autorità di vigilanza del settore. I dati
					forniti saranno conservati, garantendone la sicurezza e la
					riservatezza, fino a dodici mesi dalla compilazione del form per
					gestire eventuali reclami. Il Titolare del trattamento dei Suoi dati
					personali è TIM S.p.A., con sede in via Gaetano Negri, n. 1 - 20123
					Milano. TIM ha nominato un Data Protection Officer per il Gruppo
					Telecom Italia, domiciliato presso TIM, via Gaetano Negri, n. 1 -
					20123 Milano, e contattabile inviando una e-mail al seguente
					indirizzo: dpo.clienticonsumer.tim@telecomitalia.it. Per richiedere o
					visionare il testo integrale dell’informativa di TIM e per esercitare
					i diritti previsti dalla normativa sulla protezione dei dati personali
					(accesso ai dati, rettifica, limitazione del trattamento,
					cancellazione, portabilità, opposizione al loro utilizzo per motivi
					legittimi, ecc.), Lei potrà contattare gratuitamente il numero 187 o
					consultare il sito www.telecomitalia.com,
					<a href="https://www.telecomitalia.com/tit/it/footer/Privacy.html">
						{' '}
						link privacy
					</a>
					.
				</p>
				<span>TIM S.p.A.</span>
			</div>
		);
	}
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/screens/Privacy/index.js